import { Navigate, Outlet, useLocation } from 'react-router-dom';

import PageProgress from 'components/progress/PageProgress';
import { LOGIN } from 'config/router/constants';
import { useCheckSamePath } from 'config/router/utils';
import { useUserManagementContext } from 'hooks/userManagement/useUserManagementContext';
import { useUserManagementService } from 'hooks/userManagement/useUserManagementService';
import { isStandalone } from 'utils/environment';

const PrivateOutlet = () => {
  const userManagementService = useUserManagementService();
  const { loading } = useUserManagementContext();
  const loggedIn = userManagementService.getFromStorage();
  const location = useLocation();
  const isSamePath = useCheckSamePath();

  if (loading) return <PageProgress />;

  if (!loggedIn && !isSamePath(LOGIN) && !isStandalone()) {
    // not logged in so redirect to login page with the return url
    return <Navigate replace state={{ from: location }} to={LOGIN} />;
  }

  return <Outlet />;
};

export default PrivateOutlet;
